import { render } from "./F2SortModal.vue?vue&type=template&id=07073ad4&ts=true"
import script from "./F2SortModal.vue?vue&type=script&lang=ts"
export * from "./F2SortModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__